import React from 'react';
import styled from 'styled-components';

const AboutMain = ({ aboutDoc }) => {
    const MianContainer = `
  .mainclass:before{
    content:url(${aboutDoc?.robot_hand?.url}) ;
   
}
`

    return (
        <div className="position-relative">
        <style>
            {MianContainer}
        </style>
            <div className="row mainclass main-container ">
                <div className="col-md-9  pb-2 ">
                    <h3 className="subtitle">{aboutDoc?.subtitle[0]?.text}</h3>
                  <ul className="list-unstyled">
                      {aboutDoc?.description_para.map(info=><li key={Date.now() + Math.random()} className="pt-4 ">{info.para1}</li>)}
                  </ul>
                </div>
                <div className="col-md-6  pt-3">
                </div>
            </div>
        </div>
    );
};

export default AboutMain;